const getLatestErrorRequest = (state) =>
  state.commonState.LoggerState.errorsArrForModal;

const getActionLists = (state) => state.commonState.LoggerState.actionsArr;

const getStateShowError = (state) =>
  state.commonState.LoggerState.errorNotifyShow;

const getIrregularModalData = (state) =>
  state.commonState.LoggerState.confirmModalData;

const getIrregularModalShow = (state) =>
  state.commonState.LoggerState.irregularCaseModalShow;

const getIsFirstTimeShow = (state) =>
  state.commonState.LoggerState.isFirstTimeShow;

export default {
  getLatestErrorRequest,
  getActionLists,
  getStateShowError,
  getIrregularModalData,
  getIrregularModalShow,
  getIsFirstTimeShow,
};
